export const USER_DATA_KEY_IN_STORAGE = 'CLOUDIKECLIENT'
export const CLIENT_KEY_IN_STORAGE = 'CLIENT'
export const USER_DATA_ADDITIONAL_KEY_IN_STORAGE = 'CLOUDIKECLIENT'
export const USER_DATA_KEY_HEADER_MOUNTBIT_AUTH = 'Mountbit-Auth'
export const USER_DATA_KEY_HEADER_MOUNTBIT_USER_AGENT  = 'Mountbit-User-Agent'
export const USER_DATA_KEY_HEADER_CONTENT_TYPE  = 'Content-Type'
export const USER_TOKEN_KEY_IN_STORAGE = 'auth_token'